/**
 * Propane Use Card
 */

// Vendors
import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';

$('.card-propane-use').each(
  (index, element) =>
    new Waypoint({
      element: $(element),
      offset: '75%',
      handler: function (direction) {
        if (direction !== 'down') return;

        $(this.element).addClass('card-propane-use--animate-in');

        setTimeout(() => {
          $(this.element).addClass('card-propane-use--in-view');
        }, 700);
      }
    })
);
